import React, { useState } from 'react'
import {Form, Button,DatePicker, Select, Modal,} from 'antd';
import GetClient from '../client/GetClient'
import dayjs from 'dayjs';
import GetGroupNum from '../ledger/GetGroupNum';
import GetUserDept from '../../cpn/GetUserDept';
import FormItemBalanceType from '../../cpn/FormItemBalanceType';
const { RangePicker } = DatePicker;
function ArapQueryModal(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    return (
        <>
            <Button style={{marginLeft:'10px'}} onClick={() => {setOpen(true)}}>查询</Button>
                <Modal 
                    width={700}
                    open={open} 
                    title='查询收支单'
                    okText="提交"
                    cancelText="取消"
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>
                            <Button onClick={() => {                                                  
                                localStorage.setItem('arapWait_query_dept','')
                                localStorage.setItem('arapWait_query_client','')
                                localStorage.setItem('arapWait_query_team_num','')
                                localStorage.setItem('arapWait_query_date_s','')
                                localStorage.setItem('arapWait_query_date_e','')
                                localStorage.setItem('arapWait_query_action','')
                                localStorage.setItem('arapWait_query_ysyf_type','')
                                localStorage.setItem('arapWait_query_eie_type_id','')
                                localStorage.setItem('arapWait_query_eie_finance_sub_type_id','')
                                props.getQuery({action:'',ysyf_type:'',eie_client_id:'',eie_arrive_date_s:'',ebn_team_num:'',eie_dept_id:'',ebn_date_s:'',eie_type_id:'',eie_finance_sub_type_id:''})                                    
                                form.resetFields();    
                                setOpen(false)
                                }}>重置</Button>
                            <CancelBtn />
                            <OkBtn />
                        </>
                    )}
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                console.log(values);
                                console.log(values);
                                props.getQuery({
                                    action:"search",
                                    ebn_date_s:values.ebn_date?dayjs(values.ebn_date[0]).format('YYYY-MM-DD'):'',
                                    ebn_date_e:values.ebn_date?dayjs(values.ebn_date[1]).format('YYYY-MM-DD'):'',
                                    eie_dept_id:values.eie_dept_id,
                                    eie_client_id:values.eie_client_id,
                                    ebn_team_num:values.ebn_team_num,                                
                                    ysyf_type:values.ysyf_type,                                
                                    eie_type_id:values.eie_type_id,                                
                                    eie_finance_sub_type_id:values.eie_finance_sub_type_id,                                
                                })
                                localStorage.setItem('arapWait_query_dept',values.eie_dept_id)
                                localStorage.setItem('arapWait_query_client',values.eie_client_id)
                                localStorage.setItem('arapWait_query_team_num',values.ebn_team_num)
                                localStorage.setItem('arapWait_query_ysyf_type',values.ysyf_type)
                                localStorage.setItem('arapWait_query_eie_type_id',values.eie_type_id?values.eie_type_id:'')
                                localStorage.setItem('arapWait_query_eie_finance_sub_type_id',values.eie_finance_sub_type_id?values.eie_finance_sub_type_id:'')
                                localStorage.setItem('arapWait_query_date_s',values.ebn_date?dayjs(values.ebn_date[0]).format('YYYY-MM-DD'):'')
                                localStorage.setItem('arapWait_query_date_e',values.ebn_date?dayjs(values.ebn_date[1]).format('YYYY-MM-DD'):'')
                                localStorage.setItem('arapWait_query_action','search')
                                setOpen(false)                                  
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });           
                    }}
                >
                    <Form 
                        form={form}
                        layout="horizonal"
                        name="form_in_modal"
                        initialValues={{                        
                            // eie_arrive_date_s:[
                            //     localStorage.getItem('arapWait_query_arrive_date_s')?localStorage.getItem('arapWait_query_arrive_date_s'):'',
                            //     localStorage.getItem('arapWait_query_arrive_date_e')?localStorage.getItem('arapWait_query_arrive_date_e'):''
                            // ],
                            // ebn_date_s: localStorage.getItem('arapWait_query_date_s')?localStorage.getItem('arapWait_query_date_s'):'',
                            // ebn_date_e: localStorage.getItem('arapWait_query_date_e')?localStorage.getItem('arapWait_query_date_e'):'',
                            // ebn_team_num:localStorage.getItem('arapWait_query_team_num'),
                            // eie_dept_id:localStorage.getItem('arapWait_query_dept'),
                            // ysyf_type:localStorage.getItem('arapWait_query_ysyf_type'),
                            // eie_client_id:localStorage.getItem('arapWait_query_client')?localStorage.getItem('arapWait_query_client'):"",
                        }}          
                        labelCol={{ span: 5 }}                
                    >
                    <GetClient 
                        label='客户'  
                        name='eie_client_id' 
                        style={{width:'250px'}}
                        getClient={(e) => {}} 
                        setClient={true}
                        initialValues={props.query.eie_client_id}
                    />   
                    <Form.Item 
                        name='ebn_date' 
                        label='出发日期'
                    >                                    
                        <RangePicker />
                    </Form.Item>
                    <GetGroupNum 
                        label='团号' 
                        wrapperCol={{span:10}} 
                        getGroupNum={(e) => {}}
                        name='ebn_team_num'
                        initialValues={localStorage.getItem('arapWait_query_team_num')}
                        style={{width:"300px"}}
                    />
                    <GetUserDept  
                        label='部门' 
                        wrapperCol={{span:19}}
                        getUserDept={(e) => {}}
                        name='eie_dept_id'
                        selectAll='true'
                        initialValues={localStorage.getItem('arapWait_query_dept')}
                        style={{width:"300px"}}
                        setDept={true}
                        value={props.eie_dept_id}
                        FormStyle={{marginBottom:'0'}}
                    />
                    <FormItemBalanceType
                        mainName='eie_type_id'
                        subName='eie_finance_sub_type_id'
                        getMainType={() => {}}
                        getSubType={() => {}}
                    />
                    <Form.Item 
                        name='ysyf_type' 
                        label='收入/支出' 
                        wrapperCol={{span:15}}
                    >                                    
                        <Select
                            value={props.query.ysyf_type}
                            style={{width:"300px"}}
                            options={[       
                                {
                                    value:"",
                                    label:'全部',
                                },
                                {
                                    value:"2",
                                    label:'收入',
                                },
                                {
                                    value:"1",
                                    label:'支出',
                                },        
                            ]}
                        />
                    </Form.Item>                  
                </Form>
            </Modal>
        </>
    )
}

export default ArapQueryModal